import axios from 'axios';
import regeneratorRuntime from 'regenerator-runtime';
import { setToken } from '../Utils/requestToken';
import AddMoney from './ActionTypes/AddMoneyTypes';
import CancelSubscription from './ActionTypes/CancelType';
import ContactUS from './ActionTypes/ContactTypes';
import CreateSubscription from './ActionTypes/CreateSub';
import forgotPassword from './ActionTypes/ForgotPassword';
import InitiateSubscription from './ActionTypes/initiatePayment';
import InviteUser from './ActionTypes/Inviteuser';
import LogoutUser from './ActionTypes/LogoutTypes';
import ProfilePic from './ActionTypes/ProfilePic';
import UserProfile from './ActionTypes/ProfileType';
import RefreshToken from './ActionTypes/RefreshToken';
import RemoveUser from './ActionTypes/RemoveUser';
import resetPassword from './ActionTypes/ResetPassword';
import SubscriptionType from './ActionTypes/SubscriptionType';
import TeamData from './ActionTypes/TeamType';
import UpdatePic from './ActionTypes/UpdatePic';
import UpdateProfile from './ActionTypes/UpdateUser';
import UserSignupType from './ActionTypes/UserSignup';
import WalletType from './ActionTypes/WalletActionTypes';
import { toast } from 'react-toastify';
import reactCookies from 'react-cookies';
import LoaderType from './ActionTypes/LoaderType';
import freeTrial from './ActionTypes/FreeTrial';
import ValidSub from './ActionTypes/ValidSub';
import freeSignup from './ActionTypes/FreeSignup';
import { initializeTrackers } from '../Utils/Trackers';
import mobileDropdwon from './ActionTypes/MobileDropdown';
import AuthService from '../services/authService';
import CheckMail from './ActionTypes/CheckMail';
import Filled_details from './ActionTypes/Filled_details';
import VerifyMail from './ActionTypes/VerifyMail';
import Product_plan from './ActionTypes/Product_plan';
import downloadInvoice from './ActionTypes/DownloadInvoice';
import CreateLite from './ActionTypes/CreateLite';
import Lite_loader from './ActionTypes/Lite_loader';
import Onboarding from './ActionTypes/Onboarding';
import VerifySignup from './ActionTypes/VerifySignup';
import ShowSignup from './ActionTypes/ShowSignup';
import validNum from './ActionTypes/ValidNum';
import subscriptions from './ActionTypes/Subscriptions';
import Multi_factor from './ActionTypes/MultiFactor';
import user_action from './ActionTypes/UserAction';
import isEnterpriseUser from './ActionTypes/EnterpriseUser';
import GetChargeTypes from './ActionTypes/GetChargeTypes';
import OpenDetailsModal from './ActionTypes/OpenDetailsModal';
import Payment from '../components/Productpage/Payment';
import CheckDailyLimit from './ActionTypes/DailyLimit';
import OpenDeskModal from './ActionTypes/OpenDeskModal';
import OpenDailyLimit from './ActionTypes/OpenDailyLimit';
import ToggleController from './ActionTypes/ToggleController';
import validCoupon from './ActionTypes/ValidateCoupon';
import { customAlphabet } from 'nanoid';
import { amounts } from '../Utils/PlanAmounts';

export const signUp = (formData, history, loader, exist) => async (dispatch) => {
  dispatch({
    type: LoaderType.SET_LOADER_TRUE,
  });
  loader(true);
  let conflict = false;
  let freeTrial = localStorage.getItem('freeTrial');
  let product = localStorage.getItem('product');
  const SignupURL = process.env.REACT_APP_BASE_URL + 'signup';
  try {
    localStorage.setItem('email', formData.email);
    await fetch(SignupURL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        data.statusCode === 409 ? (conflict = true) : (conflict = false);
        data.statusCode === 409 ? exist(true) : exist(false);
        loader(false);
        dispatch({
          type: 'signUp',
          payload: data,
          conflict: conflict,
        });
        dispatch({
          type: LoaderType.SET_LOADER_FALSE,
        });
        if (data.statusCode === 200) {
          if (conflict === false) {
            loader(false);
            localStorage.removeItem('couponCode');
            if (freeTrial) {
              dispatch(free_trial(true, product, 'ft'));
              dispatch(verifySignup(true));
              // history.push('/verify');
              // AuthService.login();
            } else {
              dispatch(free_trial(false));
              dispatch(verifySignup(true));
              // history.push('/verify');
              // AuthService.login();
            }
          }
        }
      });
    // submit_hubspot_form(formData);
  } catch (e) {
    console.log(e);
  }
};
export const showSignup = (show) => ({
  type: ShowSignup.SHOW_SIGNUP,
  status: show,
});

export const currTutorial = (product) => ({
  type: 'currentTutorial',
  curr: product,
});

export const valid_coupon = (coupon) => async (dispatch) => {
  let isValid;
  const verifyCouponURL = process.env.REACT_APP_PAYMENT_URL + 'coupon/validate';
  try {
    await fetch(verifyCouponURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        couponCode: coupon,
      }),
    })
      .then((response) => {
        if (response.status !== 200) {
          isValid = false;
        } else {
          isValid = true;
          localStorage.setItem('couponCode', coupon);
        }
        return response.json();
      })
      .then((data) =>
        dispatch({
          type: validCoupon.COUPON_IS_VALID,
          payload: data,
          valid: isValid,
          plan: data?.plan_name,
        }),
      );
  } catch (error) {
    dispatch({
      type: validCoupon.COUPON_IS_VALID,
      payload: error.err,
      valid: isValid,
    });
  }
};

export const hubspotTrack = (formName, options) => {
  const portalId = process.env.REACT_APP_HUBSPOT_PORTAL;
  const forms = {
    signup: 'af73eec2-1a19-45eb-8660-e43d83a2765d',
    buyCompanyCreation: 'eac03c3e-90c2-4693-b66a-46f9b09f88e6',
  };
  try {
    axios.post(
      `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${forms[formName]}`,
      {
        fields: [
          {
            name: 'email',
            value: options.email,
          },
        ],
      },
    );
  } catch (error) {
    console.log(error);
  }
};

// export const submit_hubspot_form = async (form) => {
//   const portalId = process.env.REACT_APP_HUBSPOT_PORTAL;
//   const formGuid = process.env.REACT_APP_HUBSPOT_FORM;
//   const config = {
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   };
//   const response = await axios.post(
//     `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
//     {
//       portalId,
//       formGuid,
//       context: {
//         pageUri: window.location.href,
//       },
//       fields: [
//         {
//           name: 'firstname',
//           value: form.name,
//         },
//         {
//           name: 'email',
//           value: form.email,
//         },
//       ],
//     },
//     config,
//   );
//   return response;
// };

export const send_mail = (email) => async (dispatch) => {
  const verifyMailURL =
    process.env.REACT_APP_BASE_URL + `user/sendVerifyEmail?email=${email}`;
  try {
    await fetch(verifyMailURL, {
      method: 'POST',
    })
      .then((response) => response.json())
      .then((data) =>
        dispatch({
          type: VerifyMail.SEND_MAIL_SUCCESS,
          payload: data,
        }) && data.statusCode === 200
          ? toast.success('Mail sent successfully')
          : toast.error(data.errorMessage),
      );
  } catch (error) { }
};

export const verifySignup = (action) => ({
  type: VerifySignup.VERIFY_SIGNUP_SUCCESS,
  status: action,
});

export const check_Mail = (email) => async (dispatch) => {
  const checkMailURL = process.env.REACT_APP_BASE_URL + 'user/exists';
  try {
    await fetch(checkMailURL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email }),
    })
      .then((response) => response.json())
      .then((data) =>
        dispatch({
          type: CheckMail.CHECK_MAIL_SUCCESS,
          payload: data.exists,
        }),
      );
  } catch (error) {
    console.error(error);
    dispatch({
      type: CheckMail.CHECK_MAIL_FAIL,
      payload: error,
    });
  }
};

export const signIn = (formData, history) => async (dispatch) => {
  let isAuthorised = false;
  let idpSignin = false;
  let profileCreated = false;
  let nanoid = customAlphabet(
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
    10,
  );
  dispatch({
    type: LoaderType.SET_LOADER_TRUE,
  });
  const SigninURL = process.env.REACT_APP_BASE_URL + 'signin';
  try {
    // const { data } = await axios.post(SigninURL, formData);
    // data.statusCode ? (isAuthorised = false) : (isAuthorised = true);
    let { keycloak, status } = await AuthService.initKeycloak(() => { }, null);
    if (status === 0) {
      isAuthorised = true;
      if (keycloak) {
        if (!!keycloak.resourceAccess['rebid-buy-public']) {
          if (
            keycloak.resourceAccess['rebid-buy-public'].roles.includes(
              'rebid-buy-enterprise',
            )
          ) {
            dispatch({
              type: isEnterpriseUser.IS_ENTERPRISE_USER,
              status: true,
              subscriptionStatus: 'ACTIVE',
            });
          }
        }
        idpSignin = ['google', 'microsoft', 'email'].includes(
          keycloak.idTokenParsed.identity_provider,
        );
        profileCreated = !!keycloak.idTokenParsed?.hasCompanyCreated;
        if (idpSignin && !profileCreated) {
          const response = await axios.post(process.env.REACT_APP_BASE_URL + 'signup', {
            name: keycloak.idTokenParsed.given_name,
            email: keycloak.idTokenParsed.email,
            password: nanoid(20),
            idpInitiatedSignup: true,
            idpProvider: keycloak.idTokenParsed.identity_provider,
            keycloakUserId: keycloak.idTokenParsed.sub,
          });
        }
      }
    }
    dispatch({
      type: 'signIn',
      payload: keycloak?.idTokenParsed,
      isAuthorised: isAuthorised,
    });
    dispatch({
      type: LoaderType.SET_LOADER_FALSE,
    });
    if (isAuthorised === true) {
      reactCookies.save('access_token', keycloak.token, { path: '/' });
      setToken(keycloak.token);
      dispatch(Getprofile());
      initializeTrackers();
      dispatch(GetprofilePic());
      dispatch(GetSubscription());
      dispatch(getWallet());
      // history.push('/product');
    }
    dispatch({
      type: LoaderType.SET_LOADER_FALSE,
      loading: false,
    });
  } catch (e) {
    console.log(e);
  }
};

export const Forgot_Password = (email) => async (dispatch) => {
  const forgotURL =
    process.env.REACT_APP_BASE_URL + 'forgot/password' + `?email=${email}`;
  let isOpen = false;
  let passwordError = '';
  dispatch({
    type: LoaderType.SET_LOADER_TRUE,
  });
  try {
    const { data } = await axios.post(forgotURL);
    data.statusCode === 200 ? (isOpen = true) : (isOpen = false);
    data.statusCode !== 200 ? (passwordError = data.status) : (passwordError = '');
    dispatch({
      type: forgotPassword.FORGOT_PASSWORD_SUCCESS,
      payload: data,
      setFpScreen: isOpen,
      passwordError: passwordError,
    });
    dispatch({
      type: LoaderType.SET_LOADER_FALSE,
    });
  } catch (error) {
    console.log(error);
  }
};

export const ResetPassword = (email, password, secretKey) => async (dispatch) => {
  const resetURL = process.env.REACT_APP_BASE_URL + 'reset/password';
  let isOpen = false;
  let passwordError = '';
  dispatch({
    type: LoaderType.SET_LOADER_TRUE,
  });
  try {
    const { data } = await axios.post(resetURL, {
      email: email,
      password: password,
      secretKey: secretKey,
    });
    data.statusCode === 200 ? (isOpen = true) : (isOpen = false);
    data.statusCode !== 200 ? (passwordError = data.status) : (passwordError = '');

    dispatch({
      type: resetPassword.RESET_PASSWORD_SUCCESS,
      payload: data,
      setResetScreen: isOpen,
      passwordError: passwordError,
    });
    dispatch({
      type: LoaderType.SET_LOADER_FALSE,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getSettings = () => async (dispatch) => {
  const UserURL = process.env.REACT_APP_BASE_URL + 'profile';
  try {
    const { data } = await axios.get(UserURL);
    dispatch({
      type: 'getProfile',
      payload: data,
    });
  } catch (e) {
    console.log(e);
  }
};

export const checkSub = (check) => ({
  type: ValidSub.SUB_SUCCESS,
  status: check,
});

export const getProduct_plan = (product, plan) => ({
  type: Product_plan.PRODUCT_PLAN_ACQUIRED,
  product: product,
  plan: plan,
});

export const checkFilledDetails = (filled) => ({
  type: Filled_details.DETAILS_SUCCESS,
  status: filled,
});

export const check_daily_limit = (set) => ({
  type: CheckDailyLimit.CHECK_DAILY_LIMIT,
  payload: set,
});

export const open_deskModal = (open) => ({
  type: OpenDeskModal.OPEN_DESK_MODAL,
  status: open,
});

export const open_dailyLimit = (open) => ({
  type: OpenDailyLimit.OPEN_DAILY_LIMIT,
  status: open,
});

export const toggle_product = (product) => ({
  type: ToggleController.SET_PRODUCT_TOGGLE,
  payload: product,
});

export const checkOnboarding = (done, call) => {
  return async (dispatch) => {
    const UserURL = process.env.REACT_APP_BASE_URL + 'profile';
    try {
      dispatch({
        type: Onboarding.ONBOARDING_SUCCESS,
        status: done,
      });
      if (call === true) {
        const { data } = await axios.post(UserURL, {
          onboarded: true,
        });
        dispatch({
          type: UpdateProfile.UPDATE_USER_SUCCESS,
          payload: data,
        });
      }
    } catch (e) {
      dispatch({
        type: Onboarding.ONBOARDING_FAIL,
        status: false,
      });
    }
  };
};

export const checkMultiFactor = (action) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: Multi_factor.MULTI_FACTOR_SUCCESS,
        status: action,
      });
    } catch (e) { }
  };
};

export const checkExclusiveUser = (
  status,
  subscriptionStatus,
  plan,
  product,
  previousPayment,
) => ({
  type: isEnterpriseUser.IS_ENTERPRISE_USER,
  status: status,
  subscriptionStatus,
  plan,
  product,
  previousPayment,
});

export const FreeSignup = (check) => ({
  type: freeSignup.SIGNUP_FREE_TRIAL,
  status: check,
});

export const updateUser = (formData) => async (dispatch) => {
  const UserURL = process.env.REACT_APP_BASE_URL + 'profile';
  try {
    const { data } = await axios.post(UserURL, formData);
    data.statusCode === 200
      ? dispatch(Getprofile()) && toast.success('User details updated successfully')
      : toast.error('Details update failed');
    dispatch({
      type: UpdateProfile.UPDATE_USER_SUCCESS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: UpdateProfile.UPDATE_USER_FAIL,
      payload: data,
    });
  }
};

export const settings = (open, tab) => ({
  type: 'settings',
  status: open,
  tab: tab,
});

export const contactUs = (open, message, enterprise, plan) => ({
  type: 'contact',
  status: open,
  msg: message,
  plan: plan,
  enterprise: enterprise,
});

export const signupState = (open) => ({
  type: 'signupState',
  status: open,
});

export const validNumber = (status) => ({
  type: validNum.VALID_NUMBER,
  status: status,
});

export const subscription_list = (list) => async (dispatch) => {
  var unique = list.filter(
    (value, index, self) =>
      index ===
      self.findIndex((t) => t.product === value.product && t.plan === value.plan),
  );
  dispatch({ type: subscriptions.FETCH_SUBSCRIPTION, payload: unique });
};

export const Getprofile = () => {
  const profileURL = process.env.REACT_APP_BASE_URL + 'profile';

  return async (dispatch) => {
    try {
      const res = await axios.get(profileURL);
      const { data } = res;
      dispatch({
        type: UserProfile.FETCH_USER_SUCCESS,
        payload: data,
      });
      data.signupComplete
        ? dispatch(checkFilledDetails(true))
        : dispatch(checkFilledDetails(false)) &&
        (localStorage.getItem('formClosed') === 'true'
          ? null
          : dispatch(open_details_modal(true, null, null, null, null)));
      data.onboarded
        ? dispatch(checkOnboarding(true, false))
        : dispatch(checkOnboarding(false, false));
      data.dailyLimitSet
        ? dispatch(check_daily_limit(true))
        : dispatch(check_daily_limit(false));
      data.multiFactorAuthEnabled
        ? dispatch(checkMultiFactor(true))
        : dispatch(checkMultiFactor(false));
    } catch (error) {
      dispatch({
        type: UserProfile.FETCH_USER_FAIL,
        payload: error,
      });
    }
  };
};

export const GetprofilePic = () => {
  const profileURL = process.env.REACT_APP_BASE_URL + 'profile/photo';

  return async (dispatch) => {
    try {
      const res = await axios.get(profileURL);
      const { data } = res;
      dispatch({
        type: ProfilePic.FETCH_PIC_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ProfilePic.FETCH_PIC_FAIL,
        payload: error,
      });
    }
  };
};

export const updatePic = (formData) => async (dispatch) => {
  const UserURL = process.env.REACT_APP_BASE_URL + 'profile/photo';
  const form = new FormData();
  form.append('file', formData);
  try {
    const { data } = await axios.post(UserURL, form);
    data.status === 200
      ? dispatch(GetprofilePic()) && toast.success('Profile pic updated')
      : toast.error('Profile pic update failed');
    dispatch({
      type: UpdatePic.UPDATE_PIC_SUCCESS,
      payload: data,
    });
  } catch (e) {
    console.log(e);
  }
};

export const GetTeam = () => {
  const userURL = process.env.REACT_APP_BASE_URL + 'team';

  return async (dispatch) => {
    try {
      const res = await axios.get(userURL);
      const { data } = res;
      dispatch({
        type: TeamData.FETCH_TEAM_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TeamData.FETCH_TEAM_FAIL,
        payload: error,
      });
      console.log(error);
    }
  };
};

export const InviteMember = (formData) => {
  const inviteURL = process.env.REACT_APP_BASE_URL + 'team/invite';

  return async (dispatch) => {
    try {
      const { data } = await axios.post(inviteURL, formData);
      data.statusCode === 200
        ? toast.success('User invited successfully')
        : toast.error('User invite failed');
      dispatch({
        type: InviteUser.INVITE_USER_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error);
    }
  };
};

export const removeMember = (target) => {
  const removeURL = process.env.REACT_APP_BASE_URL + 'team/remove';

  return async (dispatch) => {
    try {
      console.log(target);

      const res = await axios.post(removeURL, {
        targetEmail: target,
      });
      const { data } = res;
      data.statusCode === 200
        ? toast.success('User removed successfully')
        : toast.error('User remove failed');
      dispatch({
        type: RemoveUser.REMOVE_USER_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error);
    }
  };
};

export const UserSignup = (formData) => {
  const UserSignupURL = process.env.REACT_APP_BASE_URL + 'internal/team/add';

  return async (dispatch) => {
    try {
      const res = await axios.post(UserSignupURL, formData);
      const { data } = res;
      dispatch({
        type: UserSignupType.USER_SIGNUP_SUCCESS,
        payload: data,
      });
      if (data.statusCode == 200) {
        window.location.href = data.redirectUrl;
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getWallet = () => {
  const WalletURL = process.env.REACT_APP_BASE_URL + 'wallet/balance';

  return async (dispatch) => {
    try {
      const res = await axios.get(WalletURL);
      const { data } = res;
      dispatch({
        type: WalletType.WALLET_FETCH_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: WalletType.WALLET_FETCH_FAIL,
        payload: error,
      });
      console.log(error);
    }
  };
};

export const download_invoice = (invoiceId) => {
  const invoiceURL =
    process.env.REACT_APP_BASE_URL +
    `wallet/paymentHistory/${invoiceId}/invoice/download`;

  return async (dispatch) => {
    try {
      await axios({
        url: invoiceURL,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: 'application/pdf' }),
        );
        const link = document.createElement('a');
        link.href = url;
        // link.setAttribute('download', 'invoice.pdf');
        // document.body.appendChild(link);
        link.download = 'invoice.pdf';
        link.click();
        dispatch({
          type: downloadInvoice.DOWNLOAD_INVOICE_SUCCESS,
          payload: response,
        });
      });
      toast.success('Invoice downloaded successfully');
    } catch (error) {
      dispatch({
        type: downloadInvoice.DOWNLOAD_INVOICE_FAIL,
        payload: error,
      });
      toast.error('No invoice found');
      console.log(error.statusCode);
    }
  };
};

export const addMoney = (formData) => {
  const addMoneyURL = process.env.REACT_APP_BASE_URL + 'wallet/balance/add';

  return async (dispatch) => {
    try {
      const res = await axios.post(addMoneyURL, formData);
      const { data } = res;

      dispatch({
        type: AddMoney.ADD_MONEY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: AddMoney.ADD_MONEY_FAIL,
        payload: error,
      });
      console.log(error);
    }
  };
};

export const GetSubscription = () => {
  const subscriptionURL = process.env.REACT_APP_BASE_URL + 'subscription/details';
  return async (dispatch) => {
    dispatch({
      type: LoaderType.SET_LOADER_TRUE,
    });
    try {
      const res = await axios.get(subscriptionURL);
      const { data } = res;
      dispatch({
        type: SubscriptionType.SUBSCRIPTION_FETCH_SUCCESS,
        payload: data,
      });
      dispatch({
        type: LoaderType.SET_LOADER_FALSE,
      });
      if (data) {
        if (data.subscriptionDTOs.length) {
          if (data.subscriptionDTOs) {
            let buySub;
            const insightsEnterprise = data.subscriptionDTOs?.find(
              (item) => item.productType === 'INSIGHTS' && item.planType === 'POC',
            );
            if (insightsEnterprise !== undefined) {
              buySub = data.subscriptionDTOs.filter(
                (item) => item.productType === 'INSIGHTS',
              );
              dispatch(getChargeTypes(buySub[0].charges));
            } else {
              buySub = data.subscriptionDTOs.filter((item) => item.productType === 'BUY');
              if (buySub[0].charges) {
                dispatch(getChargeTypes(buySub[0].charges));
              }
            }
          }
        }
      }
    } catch (error) {
      dispatch({
        type: SubscriptionType.SUBSCRIPTION_FETCH_FAIL,
        payload: error,
      });
    }
  };
};

export const getChargeTypes = (subscriptionCharges) => ({
  type: GetChargeTypes.GET_CHARGE_TYPES,
  subscriptionCharges: subscriptionCharges,
});

export const open_details_modal = (open, activity, product, plan, types) => ({
  type: OpenDetailsModal.OPEN_DETAILS_MODAL,
  status: open,
  activity,
  plan,
  types,
  product,
});

export const createLitePlan = (
  formbody,
  action,
  plan,
  email,
  product,
  type,
  history,
  loader,
) => {
  return async (dispatch) => {
    loader(true);
    const UserURL = process.env.REACT_APP_BASE_URL + 'profile';
    try {
      const { data } = await axios.post(UserURL, formbody);
      dispatch({
        type: UpdateProfile.UPDATE_USER_SUCCESS,
        payload: data,
      });
      if (data.statusCode === 200) {
        loader(false);
        toast.success('All set with ReBid products');
        dispatch(Getprofile());
        if (action === 'redirect') {
          if (product === 'BUY') {
            dispatch(open_details_modal(false, null, null, null, null));
            window.open(`${process.env.REACT_APP_BUY_URL}#Login`, '_blank');
          }
          if (product === 'DESK') {
            dispatch(open_details_modal(false, null, null, null, null));
            dispatch(open_deskModal(true));
          }
        }
        if (action === 'payment') {
          dispatch(open_details_modal(false, null, null, null, null));
          Payment(
            plan && plan,
            email && email,
            product && product,
            type && type,
            null,
            null,
            loader,
            null,
            history,
          );
        }
        if (action === 'modal') {
          dispatch(open_details_modal(false, null, null, null, null));
          dispatch(free_trial(true, product && product, plan && plan, amounts[plan]));
        }
        if (action === null) {
          dispatch(open_details_modal(false, null, null, null, null));
        }
      } else {
        toast.error('Something went wrong');
      }
    } catch (e) {
      dispatch({
        type: UpdateProfile.UPDATE_USER_FAIL,
        payload: data,
      });
    }
  };
};

export const RefreshUser = (body) => {
  const refreshURL = process.env.REACT_APP_BASE_URL + 'refresh/token';
  return async (dispatch) => {
    try {
      const res = await axios.post(refreshURL, body);
      const { data } = res;
      dispatch({
        type: RefreshToken.REFRESH_TOKEN_SUCCESS,
        payload: data,
      });
      // if (data.refresh_token === null) {
      //   dispatch(Logout());
      // }
    } catch (error) {
      dispatch({
        type: RefreshToken.REFRESH_TOKEN_FAIL,
        payload: error,
      });
    }
  };
};

export const createPayg = () => {
  const paygURL = process.env.REACT_APP_BASE_URL + 'subscription/create';
  return async (dispatch) => {
    try {
      const body = {
        product: 'DESK',
        planType: 'PAYG',
      };
      const res = await axios.post(paygURL, body);
      const { data } = res;
      dispatch({
        type: 'Payg_creation',
        payload: data,
      });
      dispatch(GetSubscription());
    } catch (error) { }
  };
};

export const contact = (formdata) => {
  const contactURL = process.env.REACT_APP_BASE_URL + 'enterprise/contact';
  return async (dispatch) => {
    try {
      const res = await axios.post(contactURL, formdata);
      const { data } = res;
      data.statusCode === 201
        ? toast.success('Contact form submitted successfully')
        : toast.error('Contact failed');
      dispatch({
        type: ContactUS.CONTACT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ContactUS.CONTACT_FAIL,
        payload: error,
      });
      console.log(error);
    }
  };
};

export const InitiatePay = (formData) => {
  const initiateURL = process.env.REACT_APP_BASE_URL + 'wallet/initiate/payment';
  return async (dispatch) => {
    dispatch({
      type: LoaderType.SET_LOADER_TRUE,
    });
    try {
      const res = await axios.post(initiateURL, formData);
      const { data } = res;

      dispatch({
        type: InitiateSubscription.INITIATE_SUCCESS,
        payload: data,
      });
      dispatch({
        type: LoaderType.SET_LOADER_FALSE,
      });
    } catch (error) {
      dispatch({
        type: InitiateSubscription.INITIATE_FAIL,
        payload: error,
      });
      console.log(error);
    }
  };
};

export const createSub = (formData) => {
  const createURL = process.env.REACT_APP_BASE_URL + 'subscription/create';
  return async (dispatch) => {
    try {
      const res = await axios.post(createURL, formData);
      const { data } = res;

      dispatch({
        type: CreateSubscription.CREATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CreateSubscription.CREATE_FAIL,
        payload: error,
      });
      console.log(error);
    }
  };
};

export const cancelSub = (history, formData, loader) => {
  const cancelURL = process.env.REACT_APP_BASE_URL + 'subscription/cancel';
  loader(true);
  return async (dispatch) => {
    try {
      const res = await axios.post(cancelURL, formData);
      const { data } = res;
      data.statusCode === 200
        ? toast.success('Subscription cancelled successfully')
        : toast.error('Subscription cancel failed');
      dispatch({
        type: CancelSubscription.CANCEL_SUCCESS,
        payload: data,
      });
      if (data.status === 'Success') {
        loader(false);
        history.push('/cancelled');
      }
    } catch (error) {
      dispatch({
        type: CancelSubscription.CANCEL_FAIL,
        payload: error,
      });
      console.log(error);
    }
  };
};

export const free_trial = (open, product, plan, type, amount, limit) => ({
  type: freeTrial.OPEN_FREE_TRIAL,
  status: open,
  product: product,
  plan: plan,
  amount: amount,
  limit: limit,
});

export const payment_modal = (open, product, plan, amount, limit) => ({
  type: 'OPEN_PAYMENT_MODAL',
  status: open,
  product: product,
  plan: plan,
  amount: amount,
  limit: limit,
});

export const mobile_dropdown = (open) => ({
  type: mobileDropdwon.MOBILE_SUCCESS,
  status: open,
});

export const multi_factor_auth = (action, logout) => {
  const actionURL = process.env.REACT_APP_BASE_URL + 'user/action';
  return async (dispatch) => {
    try {
      const res = await axios.post(actionURL, action);
      const { data } = res;

      dispatch({
        type: user_action.USER_ACTION_SUCCESS,
        payload: data,
      });
      data.statusCode === 200 ? dispatch(Getprofile()) : null;
      logout && data.statusCode === 200 ? dispatch(Logout()) : null;
    } catch (error) {
      dispatch({
        type: user_action.USER_ACTION_FAIL,
        payload: error,
      });
      console.log(error);
    }
  };
};

export const Logout = (history) => {
  return async (dispatch) => {
    try {
      localStorage.removeItem('formClosed');
      localStorage.removeItem('curr');
      reactCookies.remove('access_token', { path: '/' });
      delete axios.defaults.headers.common['Authorization'];
      // setTimeout(() => {
      //   dispatch(showSignup(false));
      // }, 0);
      AuthService.logout();
      dispatch({
        type: LogoutUser.LOGOUT_USER_SUCCESS,
      });
    } catch (error) {
      console.log(error);
    }
  };
};
